/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlatformAnalyticsEntityBreakdown
 */
export interface PlatformAnalyticsEntityBreakdown {
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsEntityBreakdown
     */
    impressions: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsEntityBreakdown
     */
    clicks: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsEntityBreakdown
     */
    completions: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsEntityBreakdown
     */
    participations: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsEntityBreakdown
     */
    claims: number;
    /**
     * 
     * @type {number}
     * @memberof PlatformAnalyticsEntityBreakdown
     */
    uniqueUsers: number;
}

/**
 * Check if a given object implements the PlatformAnalyticsEntityBreakdown interface.
 */
export function instanceOfPlatformAnalyticsEntityBreakdown(value: object): value is PlatformAnalyticsEntityBreakdown {
    if (!('impressions' in value) || value['impressions'] === undefined) return false;
    if (!('clicks' in value) || value['clicks'] === undefined) return false;
    if (!('completions' in value) || value['completions'] === undefined) return false;
    if (!('participations' in value) || value['participations'] === undefined) return false;
    if (!('claims' in value) || value['claims'] === undefined) return false;
    if (!('uniqueUsers' in value) || value['uniqueUsers'] === undefined) return false;
    return true;
}

export function PlatformAnalyticsEntityBreakdownFromJSON(json: any): PlatformAnalyticsEntityBreakdown {
    return PlatformAnalyticsEntityBreakdownFromJSONTyped(json, false);
}

export function PlatformAnalyticsEntityBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformAnalyticsEntityBreakdown {
    if (json == null) {
        return json;
    }
    return {
        
        'impressions': json['impressions'],
        'clicks': json['clicks'],
        'completions': json['completions'],
        'participations': json['participations'],
        'claims': json['claims'],
        'uniqueUsers': json['uniqueUsers'],
    };
}

export function PlatformAnalyticsEntityBreakdownToJSON(json: any): PlatformAnalyticsEntityBreakdown {
    return PlatformAnalyticsEntityBreakdownToJSONTyped(json, false);
}

export function PlatformAnalyticsEntityBreakdownToJSONTyped(value?: PlatformAnalyticsEntityBreakdown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'impressions': value['impressions'],
        'clicks': value['clicks'],
        'completions': value['completions'],
        'participations': value['participations'],
        'claims': value['claims'],
        'uniqueUsers': value['uniqueUsers'],
    };
}

